import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../redux/ReportAction";
import { useNavigate } from "react-router-dom";
import DateRangeComp from "../../common/DateRangeComp";
import { subDays, format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { AgentDownlineMember } from "./AgentDownlineMember";
import { GameSummaryDetail } from "./GameSummaryDetail";

export const GameSummary = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const [selCompanyCode, setSelCompanyCode] = useState(null);
  const [selCompanyName, setSelCompanyName] = useState(null);
  const [memberReportDetailsVisible, setMemberReportDetailsVisible] =
    useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const timeZone = "Asia/Kuala_Lumpur";

  useEffect(() => {
    const timeZone = "Asia/Kuala_Lumpur";
    const queryParams = {
      action: "companygamesummary",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };
    dispatch(actions.callAgentReportList(queryParams));
  }, [dispatch]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };
  const handleSearchClick = () => {
    const queryParams = {
      action: "companygamesummary",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };

    dispatch(actions.callAgentReportList(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };
  const customCardClass =
    "rounded d-flex align-items-center justify-content-spacebetween py-2";

  return (
    <div style={{ width: "98%", margin: "5px auto" }}>
      <GameSummaryDetail
        selCompanyCode={selCompanyCode}
        selCompanyName={selCompanyName}
        fromDate={fromDate}
        toDate={toDate}
        memberReportDetailsVisible={memberReportDetailsVisible}
        onClose={() => setMemberReportDetailsVisible(false)}
      />
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div>
        <h2>{intl.formatMessage({ id: "gameSummary" })}</h2>
      </div>
      <div className="dateSearch-div">
        <div className="dateRange-div">
          <DateRangeComp
            initialRange={[
              { startDate: fromDate, endDate: toDate, key: "selection" },
            ]}
            onDateChange={handleDateChange}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      <div>
        {reportState && reportState.agentReportLists && (
          <div
            className={`${customCardClass} gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
            style={{
              border: "1px solid grey",
              padding: "2px",
              margin: "10px 0 ",
            }}
          >
            <div style={{ width: "100%" }}>
              <table
                className="text-start table-report"
                style={{
                  width: "100%",
                  minWidth: "600px",
                }}
              >
                <tbody>
                  <tr
                    style={{
                      borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                    }}
                  >
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "topup" }) +
                        " : " +
                        reportState.agentReportLists.totaltopup}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "withdraw" }) +
                        " : " +
                        reportState.agentReportLists.totalwithdraw}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "companyProfit" })}
                      {" : "}
                      <span
                        style={{
                          color:
                            reportState.agentReportLists.totalcompanyprofit.includes(
                              "-"
                            )
                              ? "red"
                              : "green",
                        }}
                      >
                        {reportState.agentReportLists.totalcompanyprofit}
                      </span>
                    </td>
                  </tr>
                  <tr
                    style={{
                      borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                    }}
                  >
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "refund" }) +
                        " : " +
                        reportState.agentReportLists.totalrefund}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "promotion" }) +
                        " : " +
                        reportState.agentReportLists.totalgamepromo}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "marketingSelfSpent" }) +
                        " : " +
                        reportState.agentReportLists.totalselfspent}
                    </td>
                  </tr>
                  <tr
                    style={{
                      borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                    }}
                  >
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "gameIn" }) +
                        " : " +
                        reportState.agentReportLists.totalgamein}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "gameOut" }) +
                        " : " +
                        reportState.agentReportLists.totalgameout}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "gameProfit" })}
                      {" : "}
                      <span
                        style={{
                          color:
                            reportState.agentReportLists.totalnetpurchase.includes(
                              "-"
                            )
                              ? "red"
                              : "green",
                        }}
                      >
                        {reportState.agentReportLists.totalnetpurchase}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "progressiveBet" }) +
                        " : " +
                        reportState.agentReportLists.totalprogressivebet}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "progressiveWin" }) +
                        " : " +
                        reportState.agentReportLists.totalprogressivewin}
                    </td>
                    <td className="col-3 td-line"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "companyName" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "promotion" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameIn" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameOut" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "profit" })}
                  </th>
                  <th className="member-cell text-nowrap text-end text-nowrap">
                    {intl.formatMessage({ id: "progressiveBet" })}
                  </th>
                  <th className="member-cell text-nowrap text-end">
                    {intl.formatMessage({ id: "progressiveWin" })}
                  </th>

                  <th className="member-cell text-nowrap text-end">
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {reportState.agentReportLists &&
                reportState.agentReportLists.companyGameSummarys &&
                reportState.agentReportLists.companyGameSummarys.length > 0 ? (
                  reportState.agentReportLists.companyGameSummarys.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile">
                          {index + 1}
                        </td>
                        <td className="member-cell text-start">
                          {report.companyname}
                        </td>
                        <td className="member-cell text-end">
                          {report.totalpromo}
                        </td>
                        <td className="member-cell text-end">
                          {report.totalin}
                        </td>
                        <td className="member-cell text-end">
                          {report.totalout}
                        </td>
                        <td
                          className="member-cell text-end"
                          style={{
                            color: report.totalprofit.includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {report.totalprofit}
                        </td>
                        <td className="member-cell text-end">
                          {report.progressivebet}
                        </td>
                        <td className="member-cell text-end">
                          {report.progressivewin}
                        </td>
                        <td>
                          <div className="d-flex justify-content-end">
                            <button
                              className="btn btn-primary mx-1"
                              onClick={() => {
                                setSelCompanyCode(report.companycode);
                                setSelCompanyName(report.companyname);
                                setMemberReportDetailsVisible(true);
                              }}
                            >
                              <i className="bi bi-exclamation-circle" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="8">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
